import { SuiteManifest } from '../manifest';
import { settingsRoutes } from './routes';

export const settingsManifest: SuiteManifest = {
  id: 'settings',
  name: 'Suite Management',
  basePath: '/settings',
  icon: 'sliders',
  description: 'Tenant suite enablement flags and module activation.',
  requiredPermission: 'platform.tenant.manage',
  nav: [
    { label: 'Suites & Modules', path: '/settings/suites', icon: 'grid', permission: 'platform.tenant.manage', group: 'Modules', status: 'live' },
  ],
  routes: settingsRoutes,
};

export default settingsManifest;
